import React, { useEffect } from 'react'

import sobreRodasLogo from '../../../assets/img/sobre-rodas.png'
import CompanyRepository from '../../../repositories/CompanyRepository';
import { openProviderSession } from '../../../services/sessionService';
import { buildAutoLoginPayload } from '../../../utils/autoLogin';
import { stripSensitiveParams } from '../../../utils/urlToken';

import './index.css'

// Botao "Sobre Rodas" do OS Digital: troca o token de uso unico por sessao da oficina.
export default function AutoLogin() {

  useEffect(() => {
    const handleAutoLogin = async () => {
      try {
        const payload = buildAutoLoginPayload(window.location.search);
        // A credencial do link sai da barra de endereço antes da chamada.
        stripSensitiveParams();
        if (!payload) {
          throw new Error("Invalid auto login link");
        }

        // a API valida a credencial, grava o cookie de sessao e devolve { company, expiresAt }
        const session = await CompanyRepository.autoLogin(payload);
        if (session.mustChangePassword) {
          window.location.href = `/provider/newpassword?token=${encodeURIComponent(session.token)}`;
          return;
        }
        openProviderSession(session);

        window.location.href = "/provider/home";
      } catch (err) {
        window.location.href = "/provider/login";
      }
    };

    handleAutoLogin();
  }, [])

  return (
    <main className="auto-login" aria-busy="true">
      <img src={sobreRodasLogo} alt="Sobre Rodas" />
      <span className="auto-login-spinner" aria-hidden="true" />
      <p role="status">Entrando na área da oficina…</p>
    </main>
  );
}
